module.exports = __webpack_public_path__ + "static/media/glasses-alt.3ced2fa1.svg";